import { render, staticRenderFns } from "./weekly.vue?vue&type=template&id=17e724f9&"
import script from "./weekly.vue?vue&type=script&lang=js&"
export * from "./weekly.vue?vue&type=script&lang=js&"
import style0 from "./weekly.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports